module.exports = __webpack_public_path__ + "static/telephone-2333a6844a8dc679d6bda9a432f5b2dc.png";